import React from 'react';
import styled from 'astroturf/react';
import { Body } from 'js/design_system/Body';
import { Hashtag } from 'js/social/shared/types';
import { Autocomplete } from 'js/social/shared/SocialEditor/Autocomplete';
import _Option from "HashtagSelector-Option.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SocialEditor/HashtagSelector.tsx?styleId=Option";


const Option = /*#__PURE__*/styled(Body, null, {
  displayName: "Option",
  styles: _Option
});

type Props = {
  anchorTop?: number;
  anchorLeft?: number;
  hashtags: Hashtag[];
  loading: boolean;
  activeIndex: number;
  onActiveIndexChange: (activeIndex: number) => void;
  onSelect: (hashtag: Hashtag) => void;
};

export const HashtagSelector: React.FC<Props> = ({
  anchorTop = 0,
  anchorLeft = 0,
  hashtags,
  loading,
  activeIndex,
  onActiveIndexChange,
  onSelect,
}) => {
  return (
    <Autocomplete
      anchorTop={anchorTop}
      anchorLeft={anchorLeft}
      items={hashtags}
      activeIndex={activeIndex}
      loading={loading}
      keyExtractor={(hashtag) => hashtag.id}
      renderItem={(hashtag) => <Option size="md">#{hashtag.hashtag}</Option>}
      onActiveIndexChange={onActiveIndexChange}
      onSelect={onSelect}
    />
  );
};
